import { useEffect, useState } from "react";
import useLightTone from "@/hooks/useLightTone";

const SECTIONS = [
  { id: "top", label: "Top" },
  { id: "services", label: "Services" },
  { id: "together", label: "Together" },
  { id: "work", label: "Work" },
  { id: "portal", label: "Portal" },
  { id: "pricing", label: "Pricing" },
  { id: "about", label: "About" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

const probeMid = () => Math.floor(window.innerHeight / 2);

export default function ScrollProgress() {
  const [active, setActive] = useState("top");
  const [visible, setVisible] = useState(false);
  const light = useLightTone(probeMid);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
      const mid = window.innerHeight * 0.4;
      let current = SECTIONS[0].id;
      for (const s of SECTIONS) {
        const el = document.getElementById(s.id);
        if (el && el.getBoundingClientRect().top <= mid) current = s.id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      aria-label="Page sections"
      data-testid="scroll-progress"
      data-light={light ? "true" : "false"}
      className={`hidden lg:flex fixed right-5 top-1/2 -translate-y-1/2 z-40 flex-col items-end gap-3 transition-opacity duration-500 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      {SECTIONS.map((s) => {
        const on = active === s.id;
        return (
          <a
            key={s.id}
            href={`#${s.id}`}
            aria-label={s.label}
            aria-current={on ? "true" : undefined}
            data-testid={`scroll-dot-${s.id}`}
            className="group flex items-center gap-3"
          >
            <span
              className={`text-[10.5px] tracking-[0.18em] uppercase transition-all duration-300 ${
                on
                  ? `${light ? "text-zinc-700" : "text-zinc-300"} opacity-100 translate-x-0`
                  : `${light ? "text-zinc-500" : "text-zinc-500"} opacity-0 translate-x-1 group-hover:opacity-100 group-hover:translate-x-0`
              }`}
            >
              {s.label}
            </span>
            <span
              className={`block rounded-full transition-all duration-300 ${
                on
                  ? `w-1.5 h-5 ${light ? "bg-zinc-900" : "bg-white"}`
                  : `w-1.5 h-1.5 ${light ? "bg-zinc-300 group-hover:bg-zinc-500" : "bg-zinc-600 group-hover:bg-zinc-400"}`
              }`}
            />
          </a>
        );
      })}
    </nav>
  );
}
